$(function () {

    if (!$('#winning-numbers').length) return;

    var $winningNumberGamesList = $('.collapse#winning-numbers-games-list')
        
		$('.navbar-collapse-toggle').click(function(){
			setTimeout(function(){  $winningNumberGamesList.css('height','16px').addClass("in");},100);
		});

});



// WEBPACK FOOTER //
// ./features/winning-numbers/winning-numbers.js